module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABRSURBVHgB7dMrDsAwDATRTdWDNidrbtoa5mMpyArwPGajJSMByK7Mj88oUDH9femw2/k1IROvgkeBLII23FoHkGEVMvEqeBXIIqi7AbkyBIAf2wYVFbI9mq8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/static/images/navbarToggler.png
// module id = 60
// module chunks = 1